module.exports = __webpack_public_path__ + "static/media/american_roulette.netent.58df4190.jpeg";